import { gql } from '@apollo/client';

export const GET_NOTES = gql`
  query GetNotes {
    getNotes {
      id
      title
      content
      isPinned
      updatedAt
      people {
        id
        name
      }
    }
  }
`;

export const CREATE_NOTE = gql`
  mutation CreateNote($note: NoteInput!) {
    createNote(note: $note) {
      id
      title
      content
      isPinned
      updatedAt
      people {
        id
        name
      }
    }
  }
`;

export const UPDATE_NOTE = gql`
  mutation UpdateNote($id: ID!, $note: NoteInput!) {
    updateNote(id: $id, note: $note) {
      id
      title
      content
      isPinned
      updatedAt
      people {
        id
        name
      }
    }
  }
`;

export const DELETE_NOTE = gql`
  mutation DeleteNote($id: ID!) {
    deleteNote(id: $id)
  }
`;

export interface NoteData {
  id: string;
  title: string;
  content: string;
  isPinned: boolean;
  updatedAt: string;
  people: Array<{ id: string; name: string }>;
}

export interface NoteFormData {
  title: string;
  content: string;
  people?: string[];
}
